// extracted by mini-css-extract-plugin
module.exports = {"tasks":"tasks-module--tasks--1zIeQ","image":"tasks-module--image--2K-1C"};